var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7209 22.1301C13.5409 22.1301 11.8709 21.3001 10.5509 17.3301L9.83086 15.1701L7.67086 14.4501C3.71086 13.1301 2.88086 11.4601 2.88086 10.2801C2.88086 9.11007 3.71086 7.43007 7.67086 6.10007L16.1609 3.27007C18.2809 2.56007 20.0509 2.77007 21.1409 3.85007C22.2309 4.93007 22.4409 6.71007 21.7309 8.83007L18.9009 17.3201C17.5709 21.3001 15.9009 22.1301 14.7209 22.1301ZM8.14086 7.53007C5.36086 8.46007 4.37086 9.56007 4.37086 10.2801C4.37086 11.0001 5.36086 12.1001 8.14086 13.0201L10.6609 13.8601C10.8809 13.9301 11.0609 14.1101 11.1309 14.3301L11.9709 16.8501C12.8909 19.6301 14.0009 20.6201 14.7209 20.6201C15.4409 20.6201 16.5409 19.6301 17.4709 16.8501L20.3009 8.36007C20.8109 6.82007 20.7209 5.56007 20.0709 4.91007C19.4209 4.26007 18.1609 4.18007 16.6309 4.69007L8.14086 7.53007Z",
    fill: "#002C63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6108 14.9C10.4208 14.9 10.2308 14.83 10.0808 14.68C9.79078 14.39 9.79078 13.91 10.0808 13.62L13.6608 10.03C13.9508 9.74 14.4308 9.74 14.7208 10.03C15.0108 10.32 15.0108 10.8 14.7208 11.09L11.1408 14.68C11.0008 14.83 10.8008 14.9 10.6108 14.9Z",
    fill: "#002C63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2);
export default __webpack_public_path__ + "static/media/send-2.c295c0cb57c75e8413d6f50ede20b4af.svg";
export { ForwardRef as ReactComponent };